var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25D366",
    d: "M17 0C8.7 0 2 6.7 2 15c0 3.4 1.1 6.6 3.2 9.2l-2.1 6.4c-.1.4 0 .8.3 1.1.1.2.4.3.6.3.1 0 .3 0 .4-.1l6.9-3.1Q14 30 17 30c8.3 0 15-6.7 15-15S25.3 0 17 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.7 20.5c-.4 1.2-1.9 2.2-3.2 2.4-.3.1-.6.1-1 .1-.8 0-2-.2-4.1-1.1-2.4-1-4.8-3.1-6.7-5.8V16c-.6-.9-1.7-2.6-1.7-4.4 0-2.2 1.1-3.3 1.5-3.8.5-.5 1.2-.8 2-.8h.5c.7 0 1.2.2 1.7 1.2l.4.8c.3.8.7 1.7.8 1.8.3.6.3 1.1 0 1.6-.1.3-.3.5-.5.7q-.15.3-.3.3l-.2.2c.3.5.9 1.4 1.7 2.1 1.2 1.1 2.1 1.4 2.6 1.6.2-.2.4-.6.7-.9l.1-.2c.5-.7 1.3-.9 2.1-.6.4.2 2.6 1.2 2.6 1.2l.2.1c.3.2.7.3.9.7.4.9.1 2.2-.1 2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.e8874341435b08eaf0001e65fa0b7a44.svg";
export { ForwardRef as ReactComponent };